import { Modal, Backdrop, Fade } from "@material-ui/core";
import ReactCrop from "react-image-crop";

import { useAppContext } from "../../_context";
import Button from "../Misc/Button";

const CropModal = ({
  aspect,
  open,
  crop,
  disabled,
  isLoading,
  onCropChange,
  onCropComplete,
  imgRef,
  newImage,
  onNewImageLoad,
  onAddPhoto,
  onCancel,
}) => {
  const [{ tx }] = useAppContext();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className="crop-modal"
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}>
      <Fade in={open}>
        <div className="crop-modal-container">
          <ReactCrop
            aspect={aspect}
            minWidth={200}
            keepSelection={true}
            crop={crop}
            disabled={disabled}
            onChange={(_, percentCrop) => onCropChange(percentCrop)}
            onComplete={(c) => onCropComplete(c)}>
            {/** Next <Image /> as a child of ReactCrop will be buggy here */}
            <img
              ref={imgRef}
              src={newImage}
              style={{ maxHeight: "89vh" }}
              alt="selected image preview"
              onLoad={onNewImageLoad}
            />
          </ReactCrop>
          <div className="crop-modal-buttons-container">
            <Button
              onClick={onAddPhoto}
              className="crop-modal-primary-btn"
              isLoading={isLoading}
              disabled={disabled}>
              {tx["crop_modal_add_btn"]}
            </Button>
            <Button color="secondary" textColor="black" onClick={onCancel}>
              {tx["crop_modal_cancel_btn"]}
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default CropModal;
